<!--
    Component: Field SElector
    Purpose:   List Fields in nominated table for insertion in expression/formula etc.
-->
<template>
    <div>
        <div class="search__wrapper">
            <b-input type="search" v-model="fieldSearchValue" placeholder="Search" debounce="300" />
        </div>
        <b-list-group class="group__item selector-list">
            <b-list-group-item v-for="fieldItem in fieldsToRender" :key="fieldItem.fieldGuid" class="selector-item "
                :active="selectedField === fieldItem" @click="setSelectedField(fieldItem)"
                @dblclick="onAddField(fieldItem)">
                <strong>{{ fieldItem.displayName }}</strong> ({{ entityUtils.getFieldDataTypeName(fieldItem).toLowerCase() }})
            </b-list-group-item>
        </b-list-group>
        <b-button id="addFieldButton" size="sm" :disabled="addFieldButtonDisabled" block @click="onAddField()">
            <font-awesome-icon :icon="['fas', 'plus']" />
            Add Field
        </b-button>
    </div>
</template>

<script>
export default {

    name: 'FieldSelector',

    inject: ['entityUtils'],

    props: [
        /** Current table. */
        'table',
        /** Array of field definition to exclude. */
        'fieldsToIgnore',
    ],

    data() {
        return {
            /** Partial Field name to filter list. */
            fieldSearchValue: '',
            /** Field {id,text} selected in list. */
            selectedField: null,
        };
    },


    watch: {
    },

    computed: {

        /** Complete list of fields for the specified table. */
        tableFields() {
            return this.table?.fields || [];
        },

        /** Filtered list of Fields to display in list. */
        fieldsToRender() {
            return this.tableFields
                /** Exclude fields to be ignored. */
                .filter(fld => !(this.fieldsToIgnore || []).length || !this.fieldsToIgnore.find(fldIgnore => fldIgnore.fieldGuid == fld.fieldGuid))
                /** Exclude fields that don't match search value. */
                .filter(fld => !this.fieldSearchValue.length || fld.displayName.toLowerCase().includes(this.fieldSearchValue.toLowerCase()));
        },

        selectedFieldName() {
            return this.selectedField?.displayName;
        },

        addFieldButtonDisabled() {
            return !this.selectedFieldName;
        },

    },

    methods: {
        setSelectedField(item) {
            this.selectedField = item === this.selectedField ? null : item;
        },
        onAddField(fieldItem) {
            const selectedField = fieldItem || this.selectedField;
            this.$emit('add-field', selectedField);
            this.selectedField = null;
        },
    },

    mounted() {
    },

};

</script>

<style lang="scss" scoped>
.selector-list {

    min-height: 120px;
    max-height: 200px;
    padding: 2px;
    border: 1px solid #ccc;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    overflow-y: auto;

    .selector-item {
        padding: 5px;

        &:not(.active):hover {
            background-color: #ffffe0;
        }
    }
}
</style>